/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";

export enum RoomType {
  RoomTypeUnknown = "RoomTypeUnknown",
  Apartment = "Apartment",
  Bungalow = "Bungalow",
  Caravan = "Caravan",
  Chalet = "Chalet",
  DeluxeBedRoom = "DeluxeBedRoom",
  Disable = "Disable",
  DoubleBedRoom = "DoubleBedRoom",
  DuplexBedRoom = "DuplexBedRoom",
  Economy = "Economy",
  FamilyRoom = "FamilyRoom",
  FourBedRoom = "FourBedRoom",
  HolidayFlat = "HolidayFlat",
  HolidayHouse = "HolidayHouse",
  Houseboat = "Houseboat",
  JuniorSuite = "JuniorSuite",
  Mobile = "Mobile",
  MultiShareRoom = "MultiShareRoom",
  Program = "Program",
  SingleBedRoom = "SingleBedRoom",
  Studio = "Studio",
  Suite = "Suite",
  Superior = "Superior",
  Tent = "Tent",
  TentPitch = "TentPitch",
  TripleBedRoom = "TripleBedRoom",
  TwinRoom = "TwinRoom",
  VacationHome = "VacationHome",
  Villa = "Villa",
  WaterBungalow = "WaterBungalow",
}

export function roomTypeFromJSON(object: any): RoomType {
  switch (object) {
    case 0:
    case "RoomTypeUnknown":
      return RoomType.RoomTypeUnknown;
    case 1:
    case "Apartment":
      return RoomType.Apartment;
    case 2:
    case "Bungalow":
      return RoomType.Bungalow;
    case 3:
    case "Caravan":
      return RoomType.Caravan;
    case 27:
    case "Chalet":
      return RoomType.Chalet;
    case 4:
    case "DeluxeBedRoom":
      return RoomType.DeluxeBedRoom;
    case 5:
    case "Disable":
      return RoomType.Disable;
    case 6:
    case "DoubleBedRoom":
      return RoomType.DoubleBedRoom;
    case 7:
    case "DuplexBedRoom":
      return RoomType.DuplexBedRoom;
    case 8:
    case "Economy":
      return RoomType.Economy;
    case 9:
    case "FamilyRoom":
      return RoomType.FamilyRoom;
    case 10:
    case "FourBedRoom":
      return RoomType.FourBedRoom;
    case 11:
    case "HolidayFlat":
      return RoomType.HolidayFlat;
    case 12:
    case "HolidayHouse":
      return RoomType.HolidayHouse;
    case 13:
    case "Houseboat":
      return RoomType.Houseboat;
    case 14:
    case "JuniorSuite":
      return RoomType.JuniorSuite;
    case 15:
    case "Mobile":
      return RoomType.Mobile;
    case 16:
    case "MultiShareRoom":
      return RoomType.MultiShareRoom;
    case 17:
    case "Program":
      return RoomType.Program;
    case 18:
    case "SingleBedRoom":
      return RoomType.SingleBedRoom;
    case 19:
    case "Studio":
      return RoomType.Studio;
    case 20:
    case "Suite":
      return RoomType.Suite;
    case 21:
    case "Superior":
      return RoomType.Superior;
    case 28:
    case "Tent":
      return RoomType.Tent;
    case 29:
    case "TentPitch":
      return RoomType.TentPitch;
    case 22:
    case "TripleBedRoom":
      return RoomType.TripleBedRoom;
    case 23:
    case "TwinRoom":
      return RoomType.TwinRoom;
    case 24:
    case "VacationHome":
      return RoomType.VacationHome;
    case 25:
    case "Villa":
      return RoomType.Villa;
    case 26:
    case "WaterBungalow":
      return RoomType.WaterBungalow;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum RoomType"
      );
  }
}

export function roomTypeToJSON(object: RoomType): string {
  switch (object) {
    case RoomType.RoomTypeUnknown:
      return "RoomTypeUnknown";
    case RoomType.Apartment:
      return "Apartment";
    case RoomType.Bungalow:
      return "Bungalow";
    case RoomType.Caravan:
      return "Caravan";
    case RoomType.Chalet:
      return "Chalet";
    case RoomType.DeluxeBedRoom:
      return "DeluxeBedRoom";
    case RoomType.Disable:
      return "Disable";
    case RoomType.DoubleBedRoom:
      return "DoubleBedRoom";
    case RoomType.DuplexBedRoom:
      return "DuplexBedRoom";
    case RoomType.Economy:
      return "Economy";
    case RoomType.FamilyRoom:
      return "FamilyRoom";
    case RoomType.FourBedRoom:
      return "FourBedRoom";
    case RoomType.HolidayFlat:
      return "HolidayFlat";
    case RoomType.HolidayHouse:
      return "HolidayHouse";
    case RoomType.Houseboat:
      return "Houseboat";
    case RoomType.JuniorSuite:
      return "JuniorSuite";
    case RoomType.Mobile:
      return "Mobile";
    case RoomType.MultiShareRoom:
      return "MultiShareRoom";
    case RoomType.Program:
      return "Program";
    case RoomType.SingleBedRoom:
      return "SingleBedRoom";
    case RoomType.Studio:
      return "Studio";
    case RoomType.Suite:
      return "Suite";
    case RoomType.Superior:
      return "Superior";
    case RoomType.Tent:
      return "Tent";
    case RoomType.TentPitch:
      return "TentPitch";
    case RoomType.TripleBedRoom:
      return "TripleBedRoom";
    case RoomType.TwinRoom:
      return "TwinRoom";
    case RoomType.VacationHome:
      return "VacationHome";
    case RoomType.Villa:
      return "Villa";
    case RoomType.WaterBungalow:
      return "WaterBungalow";
    default:
      return "UNKNOWN";
  }
}

export function roomTypeToNumber(object: RoomType): number {
  switch (object) {
    case RoomType.RoomTypeUnknown:
      return 0;
    case RoomType.Apartment:
      return 1;
    case RoomType.Bungalow:
      return 2;
    case RoomType.Caravan:
      return 3;
    case RoomType.Chalet:
      return 27;
    case RoomType.DeluxeBedRoom:
      return 4;
    case RoomType.Disable:
      return 5;
    case RoomType.DoubleBedRoom:
      return 6;
    case RoomType.DuplexBedRoom:
      return 7;
    case RoomType.Economy:
      return 8;
    case RoomType.FamilyRoom:
      return 9;
    case RoomType.FourBedRoom:
      return 10;
    case RoomType.HolidayFlat:
      return 11;
    case RoomType.HolidayHouse:
      return 12;
    case RoomType.Houseboat:
      return 13;
    case RoomType.JuniorSuite:
      return 14;
    case RoomType.Mobile:
      return 15;
    case RoomType.MultiShareRoom:
      return 16;
    case RoomType.Program:
      return 17;
    case RoomType.SingleBedRoom:
      return 18;
    case RoomType.Studio:
      return 19;
    case RoomType.Suite:
      return 20;
    case RoomType.Superior:
      return 21;
    case RoomType.Tent:
      return 28;
    case RoomType.TentPitch:
      return 29;
    case RoomType.TripleBedRoom:
      return 22;
    case RoomType.TwinRoom:
      return 23;
    case RoomType.VacationHome:
      return 24;
    case RoomType.Villa:
      return 25;
    case RoomType.WaterBungalow:
      return 26;
    default:
      return 0;
  }
}

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}
